import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { StatsBlock } from "./StatsBlock";


export function VetStats() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/reports/vet-stats").then(r => setS(r.data)).catch(() => {}); }, []);
  if (!s) return <div className="text-[#8a938c]">Yükleniyor...</div>;
  return (
    <div className="space-y-10">
      <StatsBlock title="Haftalık İstatistik (Son 7 Gün)" data={s.weekly} testId="weekly-stats" />
      <div className="h-px bg-[#E5E2DC]" />
      <StatsBlock title="Aylık İstatistik (Son 30 Gün)" data={s.monthly} testId="monthly-stats" />
    </div>
  );
}


// -- Personel Performans Karnesi --
